import { Component, Output, EventEmitter, Input, OnChanges, ChangeDetectorRef } from "@angular/core"
import { FormControl } from "@angular/forms"
import { Observable, Subscription } from "rxjs"
import { map, startWith } from "rxjs/operators"
import {environment} from "../../../environments/environment";

@Component({
	selector: "app-poi-autocomplete",
	templateUrl: "./poi-autocomplete.component.html",
	styleUrls: ["./poi-autocomplete.component.scss"]
})
export class PoiAutocompleteComponent implements OnChanges {
	@Output() placeSelected = new EventEmitter<any>()
	@Output() placeChanged = new EventEmitter<any>()
	env = environment;
	@Input() label: string
	@Input() index: string | number
	@Input() poiList: any[] = []
	@Input() popList: any[] = []
	@Input() autocompletePop: boolean;
	@Input() disabled: boolean = false;

	popPoiControl = new FormControl()
	popPoiOptions: Observable<string[]>
	placeholder: string = "Select Poi"

	itemHeight = 48
	listHeight: number = 200
	listHeightSubscribe: Subscription
	virtualScrollSubscribed = false

	public poi: any[]
	public completeList: any[] = []

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit() {
		this.virtualScrollSubscription()
		this.placeholder = this.autocompletePop === true ? "Select Pop or Poi" : "Select Poi"
	}
	
	ngOnDestroy() {
		this.listHeightSubscribe?.unsubscribe()
	}
	
	ngOnChanges(changes) {
		this.popPoiControl.setValue(this.label || "")
		this.label = changes.label?.currentValue || ""

		if (changes.poiList || changes.popList) {
			this._initAutoComplete();
		}


		this.cdr.detectChanges()
	}

	emitPoiOrPop(e) {
		this.popPoiControl.setValue(e?.address || "")
		const original_type = e.tipologia_building==='POI'?'POI':'POP'
		this.placeSelected.emit({ point: {...e, tipologia_building: 'POI', original_type}, isValid: true })
	}

	private virtualScrollSubscription = () => {
		if (!this.virtualScrollSubscribed && this.popPoiOptions) {
			this.virtualScrollSubscribed = true

			this.listHeightSubscribe = this.popPoiOptions.subscribe(res => {
				this.listHeight = res.length * this.itemHeight
			})
		}
	}

	private _filter = (value: string | any, list): string[] => {
		const filterValue =
			typeof value === "string" ? value.toLowerCase() : value.address ? value.address.toLowerCase() : ""
		return list.filter(option => option.address.toLowerCase().includes(filterValue))
	}

	private _initAutoComplete() {
		if (this.poiList?.length) {
			for (let poi of this.poiList) {
				if (poi.fullname) {
					poi.address = poi.fullname
				}
			}
			this.completeList = this.poiList

			if (this.autocompletePop && this.popList?.length) {
				this.popList = this.transformPop(this.popList)
				this.completeList = this.poiList.concat(this.popList)
			}

			if (this.completeList.length) {
				this.popPoiOptions = this.popPoiControl.valueChanges.pipe(
					startWith(""),
					map(value => this._filter(value, this.completeList))
				)

				//this.virtualScrollSubscription()
			}
		}
	}

	private transformPop(list) {
		let newList = JSON.parse(JSON.stringify(list))
		for (let i = 0; i < list.length; i++) {
			newList[i]["address"] = list[i].nome
			newList[i]["fullname"] = list[i].nome
			newList[i]["coordinates"] = {
				lat: list[i]?.coordinates?.coordinates[1],
				lng: list[i]?.coordinates?.coordinates[0],
			}
		}
		return newList
	}

	trackByAddress(index, item) {
		return item.address
	}


	clearAll(event?) {
		if (event) {
			if (!event.value) {
				this.placeChanged.emit({ point: null, isValid: false });
			}
		} else {
			this.label = '';
			this.placeChanged.emit({point: null, isValid: false}
			);
		}
	}

}
